module.exports = __webpack_public_path__ + "img/SI-compare@2x.3769e58.png";